<template>
  <el-form label-position="right" label-width="120px">
    <el-form-item v-for="column in columns" :key="column.prop" :label="column.label">
      <el-input v-model="project[column.prop]" readonly></el-input>
    </el-form-item>
    
    <el-form-item :label="project.pid ? '分包介绍:' : '项目介绍:'">
      <el-input v-model="project.projectIntroduce" :rows="3" type="textarea" :placeholder="project.pid ? '分包介绍:' : '项目介绍:'"
        readonly />
    </el-form-item>
    <el-form-item label="电子围栏:">
      <el-button type="primary" icon="share" @click="fenceVisible=true" circle></el-button>
    </el-form-item>

    <electronic-fence-map v-model="fenceVisible" :electronicFence="project.electronicFence" />
  </el-form>
</template>
<script>
import { defineComponent } from "vue";
import ElectronicFenceMap from './ElectronicFenceMap.vue'

export default defineComponent({
  components: { ElectronicFenceMap },
  data() {
    return {
      fenceVisible: false, // 电子围栏显示
      projectColumns: [
        { label: '项目名称:', prop: 'projectName' },
        { label: '项目编号:', prop: 'projectNum' },
        { label: '项目简称:', prop: 'projectShortName' },
        { label: '项目状态:', prop: 'statusName' },
        { label: '项目开始时间:', prop: 'startUpTime' },
        { label: '预计结束时间:', prop: 'planCompleteTime' },
        { label: '负责人:', prop: 'directorName' },
        { label: '负责人电话:', prop: 'directorPhone' },
        { label: '项目联系人:', prop: 'contactsName' },
        { label: '联系人电话:', prop: 'contactsPhone' }
      ],
      subProjectColumns: [
        { label: '工区(分部):', prop: 'projectName' },
        { label: '分包单位名称:', prop: 'subcontractorName' },
        { label: '简称:', prop: 'projectShortName' },
        { label: '负责人:', prop: 'directorName' },
        { label: '负责人电话:', prop: 'directorPhone' }
      ]
    };
  },
  props: {
    project: Object
  },
  computed: {
    columns() {
      return this.project.pid ? this.subProjectColumns : this.projectColumns;
    }
  }
});
</script>